import { resolveLocale } from '@/lib/i18n/config';

const PREFIX_CURRENCIES = new Set(['USD']);
const SUFFIX_CURRENCIES = new Set(['EUR', 'XOF']);
const NUMBER_TYPES = new Set([
  'integer',
  'group',
  'decimal',
  'fraction',
  'minusSign',
  'plusSign',
  'percentSign',
  'nan',
  'infinity',
]);

export function formatCurrencyValue(
  value,
  {
    currency = 'USD',
    locale,
    maximumFractionDigits = currency === 'XOF' ? 0 : 2,
  } = {},
) {
  const amount = Number(value || 0);
  const formatter = new Intl.NumberFormat(
    locale ? resolveLocale(locale) : undefined,
    {
      style: 'currency',
      currency,
      currencyDisplay: currency === 'USD' ? 'narrowSymbol' : 'symbol',
      maximumFractionDigits,
    },
  );

  if (PREFIX_CURRENCIES.has(currency)) {
    const parts = formatter.formatToParts(amount);
    const currencyIndex = parts.findIndex((part) => part.type === 'currency');
    const firstNumberIndex = parts.findIndex((part) =>
      NUMBER_TYPES.has(part.type),
    );

    if (
      currencyIndex !== -1 &&
      firstNumberIndex !== -1 &&
      currencyIndex > firstNumberIndex
    ) {
      const numericParts = parts.filter(
        (part, index) =>
          index !== currencyIndex &&
          !(index === currencyIndex - 1 && part.type === 'literal'),
      );

      return `${parts[currencyIndex].value}${numericParts
        .map((part) => part.value)
        .join('')}`;
    }
  }

  if (!SUFFIX_CURRENCIES.has(currency)) {
    return formatter.format(amount);
  }

  const parts = formatter.formatToParts(amount);
  const currencyIndex = parts.findIndex((part) => part.type === 'currency');
  const firstNumberIndex = parts.findIndex((part) =>
    NUMBER_TYPES.has(part.type),
  );

  if (
    currencyIndex === -1 ||
    firstNumberIndex === -1 ||
    currencyIndex > firstNumberIndex
  ) {
    return formatter.format(amount);
  }

  const separator =
    parts[currencyIndex + 1]?.type === 'literal'
      ? parts[currencyIndex + 1].value
      : '';
  const numericParts = parts.filter(
    (part, index) =>
      index !== currencyIndex &&
      !(index === currencyIndex + 1 && part.type === 'literal'),
  );

  return `${numericParts.map((part) => part.value).join('')}${separator}${parts[currencyIndex].value}`;
}
